"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDITOR_TYPE = void 0;
var EDITOR_TYPE;
(function (EDITOR_TYPE) {
    EDITOR_TYPE["ADI"] = "onboarding";
    EDITOR_TYPE["Editor"] = "editor";
    EDITOR_TYPE["EditorX"] = "editor_x";
})(EDITOR_TYPE = exports.EDITOR_TYPE || (exports.EDITOR_TYPE = {}));
//# sourceMappingURL=editor-type.js.map